// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsLtc = {
  benefits_section_ltc: {
    contentful_name: '[DEFAULT] Benefits Section - LTC ',
    header_who_you_can_cover: '您可以为谁投保',
    who_you_can_cover: {
      coverage_disclaimer_available_to_all: '一般情况下,儿童可以被承保。',
      coverage_disclaimer_available_to_partners: '{plan}保险不适用于儿童。您可以为配偶或伴侣投保。',
      coverage_disclaimer_spouses_and_children: '{plan}保险不适用于伴侣。您可以为配偶和儿童投保。',
      coverage_disclaimer_available_to_spouses: '{plan}保险不适用于儿童或伴侣。您可以为配偶投保。',
      coverage_disclaimer_available_to_children: '{plan}保险不适用于配偶。您可以为伴侣和儿童投保。',
      coverage_disclaimer_available_to_partners_only: '{plan}保险不适用于配偶或儿童。您可以为伴侣投保。',
      coverage_disclaimer_available_to_children_only: '{plan}保险不适用于配偶或伴侣。您可以为儿童投保。',
      coverage_disclaimer_available_to_none: '{plan}保险不适用于家庭成员。',
    },
    header_portability: '便携性',
    portability_text: '您可使用的计划具有可携性,因此即使您更换工作或完全停止工作,也可以继续保留该计划。',
    header_evidence_of_insurability: '可保性证明',
    evidence_of_insurability: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '要符合此类计划的资格,您可能需要提供可保性证明。这可能意味着需要回答一些关于',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '您的年龄',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '和烟草使用情况的问题。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    header_long_term_care_coverage: '长期护理保险',
    long_term_care_coverage_para1_text:
      '如果您符合申请理赔的条件,您需要等待{eliminationPeriod}天的等待期(也称为免赔期),之后才能开始使用您的长期护理保险。',
    long_term_care_coverage_para2_text:
      '一旦您度过等待期,您可以在{paymentNumMonths}个月内按月获取人寿保险计划的{paymentPercentage}%,用于支付长期护理费用。',
    long_term_care_coverage_para2_amount_text:
      '一旦您度过等待期,您就可以使用保单中的{paymentAmount}用于长期护理。',
    header_more_about_this_plan: '关于此计划的更多信息',
    cost_varies_tooltip: '您的保费可能取决于您的年龄,并且您可能需要接受健康检查以确定承保资格。',
    tooltips: {
      yourAge:
        '大多数保险政策对被保险人设有年龄上限,通常在65岁至80岁之间,因此请务必在保单文件中核实具体年龄限制。',
    },
  },
};
